import { COUPONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

//
const get_coupon_request = () => {
  return {
    type: couponsTypes.get.request
  }
}

const get_coupon_success = (response) => {
  return {
    type: couponsTypes.get.success,
    payload: response.data.coupon
  }
}

const get_coupon_failure = (messages) => {
  return {
    type: couponsTypes.get.failure,
    payload: messages
  }
}

const get_coupon = (coupon_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_coupon_request())

    // Request
    axios.get(
      formatRoute(COUPONS_ROUTES.get, {id: coupon_id})
    ).then( response => {
      // success
      dispatch( get_coupon_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching coupon."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_coupon_failure(errors))
    })
  }

}

export {
  get_coupon
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/get.js